import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { SourceType } from "@core/api";
import { factory, useProps, useStyles } from "@components/mantine";
import { SourceIdentityCategoryIcon } from "./source-identity-category-icon/SourceIdentityCategoryIcon.js";
import { SourceIdentityName } from "./source-identity-name/SourceIdentityName.js";
import { SourceIdentityTypeImage } from "./source-identity-type-image/SourceIdentityTypeImage.js";
import { SourceIdentityTypeLabel } from "./source-identity-type-label/SourceIdentityTypeLabel.js";
import { SourceIdentityVisibilityIcon } from "./source-identity-visibility-icon/SourceIdentityVisibilityIcon.js";
import SourceIdentityClasses from "./SourceIdentity.module.css";
import { SourceIdentityCardVariant } from "./SourceIdentityCardVariant.js";
import { SourceIdentityProvider } from "./SourceIdentityContext.js";
import { SourceIdentityCustomVariant } from "./SourceIdentityCustomVariant.js";
import { SourceIdentityListVariant } from "./SourceIdentityListVariant.js";
var defaultProps = {
    variant: "custom"
};
var sourceIdentityVariants = {
    card: SourceIdentityCardVariant,
    custom: SourceIdentityCustomVariant,
    list: SourceIdentityListVariant
};
/**
 * The SourceIdentity component is used to display the identity of a source and its various subcomponents.
 *
 * @see the storybook examples for more details.
 */ export var SourceIdentity = factory(function(props, ref) {
    var _ref = useProps("SourceIdentity", defaultProps, props), badge = _ref.badge, classNames = _ref.classNames, source = _ref.source, styles = _ref.styles, unstyled = _ref.unstyled, variant = _ref.variant, vars = _ref.vars, others = _object_without_properties(_ref, [
        "badge",
        "classNames",
        "source",
        "styles",
        "unstyled",
        "variant",
        "vars"
    ]);
    var getStyles = useStyles({
        name: "SourceIdentity",
        classes: SourceIdentityClasses,
        props: props,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars
    });
    var currentVariant = variant !== null && variant !== void 0 ? variant : "custom";
    var _currentVariant;
    var SourceIdentityComponent = (_currentVariant = sourceIdentityVariants[currentVariant]) !== null && _currentVariant !== void 0 ? _currentVariant : null;
    return /*#__PURE__*/ _jsx(SourceIdentityProvider, {
        value: _object_spread_props(_object_spread({
            badge: badge,
            variant: currentVariant,
            sourceType: SourceType.CUSTOM
        }, source), {
            getStyles: getStyles
        }),
        children: /*#__PURE__*/ _jsx(SourceIdentityComponent, _object_spread({
            ref: ref,
            "data-variant": variant
        }, others))
    });
});
SourceIdentity.displayName = "@resourceIdentity/source/SourceIdentity";
SourceIdentity.CategoryIcon = SourceIdentityCategoryIcon;
SourceIdentity.Name = SourceIdentityName;
SourceIdentity.TypeImage = SourceIdentityTypeImage;
SourceIdentity.TypeLabel = SourceIdentityTypeLabel;
SourceIdentity.VisibilityIcon = SourceIdentityVisibilityIcon;

//# sourceMappingURL=SourceIdentity.js.map